<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :md="6" :sm="12">
            <a-form-item label="奖惩对象类型">
              <j-dict-select-tag placeholder="选择奖惩对象类型" v-model="queryParam.regulationTargetType" dict-code="regulation_target_type"></j-dict-select-tag>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12">
            <a-form-item label="奖励类型">
              <j-dict-select-tag placeholder="选择奖励类型" v-model="queryParam.regulationType" dict-code="regulation_type"></j-dict-select-tag>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
        <a-button type="primary" icon="download" @click="handleExportXls('企业奖惩记录表')">导出</a-button>
        <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl"
                  @change="handleImportExcel">
          <a-button type="primary" icon="import">导入</a-button>
        </a-upload>
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel">
              <a-icon type="delete"/>
              删除
            </a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> 批量操作
            <a-icon type="down"/>
          </a-button>
        </a-dropdown>
      </div>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{
          selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical"/>
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down"/></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <tm-enterprise-regulation-records-modal ref="modalForm" @ok="modalFormOk"></tm-enterprise-regulation-records-modal>
  </a-card>
</template>

<script>
import {FzisListMixin} from '@/mixins/FzisListMixin'
import JInput from '@/components/fzis/JInput'
import JSuperQuery from "@comp/fzis/JSuperQuery";
import TmEnterpriseRegulationRecordsModal from "@views/enterprise/modules/TmEnterpriseRegulationRecordsModal";

export default {
  name: "TmEnterpriseRegulationRecords",
  mixins: [FzisListMixin],
  components: {
    JInput,
    JSuperQuery,
    TmEnterpriseRegulationRecordsModal,
  },
  data() {
    return {
      description: '企业奖惩记录管理页面',
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '奖惩对象类型',
          align: "center",
          dataIndex: 'regulationTargetType',
          customRender: function (text) {
            if (text == '1')
              return '招标人'
            else if (text == '2')
              return '招标代理'
            else if (text == '3')
              return '投标人'
            else if (text == '4')
              return '项目经理'
            else if (text == '5')
              return '总监理'
            else if (text == '6')
              return '总工程师'
            else if (text == '7')
              return '评标专家'
            else if (text == '8')
              return '其他'
          }
        },
        {
          title: '奖惩类型',
          align: "center",
          dataIndex: 'regulationType',
          customRender: function (text) {
            if (text == '1')
              return '奖励'
            else if (text == '2')
              return '警告'
            else if (text == '3')
              return '罚款'
            else if (text == '4')
              return '责令停产停业'
            else if (text == '5')
              return '其他行政处罚或不良记录'
          }
        },
        {
          title: '奖惩对象代码',
          align: "center",
          dataIndex: 'regulationTargetCode'
        },
        {
          title: '奖惩时间',
          align: "center",
          dataIndex: 'regulationTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          scopedSlots: {customRender: 'action'},
        }
      ],
      // TODO 这边接口要做修改
      url: {
        list: "/ebid-ce/tmEnterpriseRegulationRecords/list",
        delete: "/ebid-ce/tmEnterpriseRegulationRecords/delete",
        deleteBatch: "/ebid-ce/tmEnterpriseRegulationRecords/deleteBatch",
        exportXlsUrl: "ebid-ce/tmEnterpriseRegulationRecords/exportXls",
        importExcelUrl: "ebid-ce/tmEnterpriseRegulationRecords/importExcel",
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
}
</script>

<style scoped>
@import '~@assets/less/common.less';
</style>